<template>
  <el-container>
    <main class="tab__container">
      <div class="clients-list__title">
        <h2 class="page__title">Клиент: {{ client.client_name }}</h2>
        <el-button v-if="activeName==='cameras'" :type="showDeletedCameras ? 'info' : 'primary'" @click="handleShowDeletedCameras">
          <template v-if="!showDeletedCameras">Показать удаленные</template>
          <template v-else>Скрыть удаленные</template>
        </el-button>
      </div>
      <el-tabs ref="tabs" v-model="activeName">
        <el-tab-pane v-for="(tab, i) in components" :name="tab.subject" :label="tab.name" :key="i">
          <component
            v-loading="loading && tab.name === 'Информация'"
            v-bind="tab.props"
            :is="tab.component"
            :client-id="id"
            :show-deleted-cameras="showDeletedCameras"
          />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import { checkPermission } from "@/core/helpers/permissions";
import { mapActions, mapState } from "vuex";
import ClientEditTab from "@/components/Client/components/tabs/ClientEditTab";
import ClientCamerasTab from "@/components/Client/components/tabs/ClientCamerasTab";
import ClientSharedCamerasTab from "@/components/Client/components/tabs/ClientSharedCamerasTab";
import ClientIntercomsTab from "@/components/Client/components/tabs/ClientIntercomsTab";

export default {
  name: "Client",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    const tabs = [
      {
        name: "Информация",
        component: ClientEditTab,
        permission: "clients:read",
        subject: "info",
      },
      {
        name: "Камеры",
        component: ClientCamerasTab,
        permission: "client_cameras:read",
        subject: "cameras",
      },
      {
        name: "Дополнительные камеры",
        component: ClientSharedCamerasTab,
        permission: "client_shared_cameras:read",
        subject: "shared_cameras",
      },
      {
        name: "Домофоны",
        component: ClientIntercomsTab,
        permission: "intercoms:read",
        subject: "intercoms",
      },
    ];
    return {
      activeName: "info",
      showDeletedCameras: false,
      loading: false,
      components: tabs.filter(({ permission }) => checkPermission(permission))
        .filter(({ subject }) => !(subject == "intercoms" && localStorage.getItem("operator") != 621 && localStorage.getItem("operator") != 1021)),
        /* ^ костыль, чтобы показывать вкладку домофонов только для Провзора(621) и vcrftest(1021). Нужно переделать, когда будет горизонтальное разграничение прав. */
    };
  },
  computed: {
    ...mapState("client", ["client"]),
  },
  watch: {
    id: {
      immediate: true,
      handler(id, prevId) {
        this.loadClient();
        if (prevId) this.$refs.tabs.setCurrentName("0");
      },
    },
  },
  methods: {
    ...mapActions("client", {
      getClient: "GET_CLIENT",
      getClientFbs: "GET_CLIENT_FBS",
    }),
    loadClient() {
      const id = this.id;
      this.loading = true;
      return this.getClient(id)
        .then(() => {
          if (this.$can("read", "clients_fbs")) {
            return this.getClientFbs(id);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleShowDeletedCameras() {
      this.showDeletedCameras = !this.showDeletedCameras;
    }
  },
};
</script>

<style>
.clients-list__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
